import React from 'react';

import { text } from 'styles/commons/text';

/**
 * @desc INAVI Maps_상품 이용약관_FREE(체험판)
 * @returns
 */
const BilingPlanFreeTerms = () => {
  return (
    <div class="content">
      <ol>
        <li>
          <strong>서비스 개요</strong>
        </li>
      </ol>
      <ul>
        <li>
          &lsquo;INAVI Maps 서비스&rsquo;란, Web과 Mobile 환경에서 지도정보를 제공하는
          위치 기반 솔루션으로, 신속한 HTTP REST API를 통해 다양한 기능을 손쉽게
          연계하고 확장할 수 있도록 설계된 Open API 플랫폼입니다.
        </li>
        <li>
          본 약관은 INAVI Maps 서비스의 특정 상품 이용에 관한 사항을 다루며, 서비스
          이용 전반에 관한 사항은 웹사이트 내 INAVI Maps 서비스 이용약관을 참고하시기
          바랍니다.
        </li>
      </ul>
      <ol start="2">
        <li>
          <strong>상품 개요</strong>
        </li>
      </ol>
      <ul>
        <li>
          &lsquo;FREE&rsquo; 상품은 API 기능 확인 및 연동 테스트를 위해 제공되는
          무료 상품입니다. 본 상품은 실제 서비스 운영 목적이 아닌 기능 검토 및
          개발 테스트 용도로 제공되며, 운영 환경 적용이 필요한 경우 유료 상품
          이용이 필요합니다.
        </li>
        <li>
          &lsquo;FREE&rsquo; 요금제는 계정당 하나의 APP(APPKEY)만 신청 및 이용이
          가능합니다.
          <ul class="sublist">
            <li>
              단, 다른 APP(APPKEY) 신청 시 기존 FREE 상품 이용 중단일의
              익일(다음 날)부터 신청이 가능합니다.
            </li>
            <li>
              상품 변경으로 인해 유료 상품 이용 이력이 남은 APP(APPKEY)로는 FREE
              상품을 다시 신청할 수 없습니다.
            </li>
          </ul>
        </li>
        <li>
          &lsquo;FREE&rsquo; 상품은 API별 일 제공량 내에서 이용할 수 있으며
          제공량을 초과한 경우 해당 API의 추가 요청이 제한됩니다.
          &lsquo;FREE&rsquo; 상품의 제공되는{' '}
          <text.Link href="/billing-plan" target="_blank">
            요금 소개
          </text.Link>
          를 통해 확인하실 수 있습니다.
        </li>
      </ul>
      <ol start="3">
        <li>
          <strong>기타</strong>
        </li>
      </ol>
      <ul>
        <li>
          회사는 INAVI Maps 서비스와 관련하여 회원에게 정해진 이용 조건에 따라 서비스
          이용 권한만을 부여하며, 회원은 이를 양도, 판매, 담보 제공 등의
          목적으로 처분할 수 없습니다. 본 약관에 따라 회원이 INAVI Maps 서비스를
          소유하거나 이에 대한 저작권을 가지는 것은 아니며, 단순히 회사로부터
          해당 서비스 이용 권한을 부여받는 것입니다. INAVI Maps 서비스는 정보 취득
          또는 개인적인 용도로만 제공되며, 회사의 사전 승인 없이 제3자에게
          공유하거나 판매하는 행위는 금지됩니다. 이를 위반할 경우 API 사용이
          제한될 수 있습니다.
        </li>
        <li>
          API의 정해진 파라미터 규격을 따르지 않거나 과도한 요청을 발생시켜
          시스템에 과부하를 유발하는 경우, 이는 부정 사용으로 판단될 수 있으며,
          이에 따라 서비스 이용이 제한될 수 있습니다.
        </li>
      </ul>
      <p>&nbsp;</p>
    </div>
  );
};

export default BilingPlanFreeTerms;
